export const formatDate = (dateString) => {
  try {
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ]

    const isValidDate = !isNaN(new Date(dateString).getTime())
    if (!isValidDate) {
      throw new Error('Invalid date format')
    }

    const date = new Date(dateString)
    const month = months[date.getMonth()]
    const year = date.getFullYear()
    const dateNumber = date.getDate()

    return `${month?.slice(0, 3)} ${dateNumber}, ${year}`
  } catch (error) {
    console.error(`Error formatting date: ${error.message}`)
    return 'Invalid Date'
  }
}

export const formatDuration = (item, key = null) => {
  if (item && (!key || item[key])) {
    const time = !key ? item : item[key]
    return `${Math.floor(time / 60) ? Math.floor(time / 60) + ` min` : ''} ${time % 60} sec`
  }
  return '-'
}

export const getRandomValue = (min, max, type) => {
  const random = Math.random() * (max - min) + min
  if (type === 'float') {
    return random.toFixed(2)
  } else {
    return Math.floor(random)
  }
}

export const generateFinalPromptStr = (obj, intialPrompt) => {
  const promptString = Object.entries(obj)?.reduce((acc, [, value]) => {
    if (value) {
      const { title, prompt, category } = value
      return acc + `, ${category}: ${prompt || title || ''}`
    } else {
      return acc
    }
  }, `${intialPrompt} `)
  return promptString?.trim() || ''
}

export const isValidUrl = (url) => {
  const pattern = /^(?:(?:https?|ftp):\/\/)?(?:www\.)?[a-z0-9-]+(?:\.[a-z0-9-]+)+[^\s]*$/i
  return !!pattern.test(url)
}
